import cn from 'classnames';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';

export enum DownloadIconVariant {
  APPLE = 'apple',
  GOOGLE = 'google',
  DOWNLOAD = 'download',
  GOOGLE_COLOR = 'googleColor',
}

export interface IDownloadIconProps extends IConDefaultType {
  variant?: DownloadIconVariant;
}

function DownloadIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = DownloadIconVariant.APPLE,
}: IDownloadIconProps) {
  const fill = color || EColorMap.gray_1;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === DownloadIconVariant.APPLE && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0546 1C16.1842 2.18299 15.7174 3.34874 15.0353 4.2056C14.3235 5.04914 13.1847 5.69434 12.0756 5.61124C11.9305 4.47293 12.4924 3.2625 13.1215 2.52401C13.8325 1.68596 15.0673 1.0439 16.0546 1ZM19.6832 7.82434C19.5594 7.89854 17.5082 9.12822 17.5307 11.636C17.5572 14.6637 20.1688 15.6656 20.2 15.6765C20.1844 15.7471 19.791 17.1222 18.8115 18.5168C17.9935 19.7453 17.1366 20.9471 15.7754 20.9683C15.1283 20.9832 14.6913 20.7965 14.236 20.6019C13.761 20.3989 13.2661 20.1874 12.4918 20.1874C11.6713 20.1874 11.1545 20.4058 10.6561 20.6163C10.2249 20.7985 9.80757 20.9748 9.21924 20.9988C7.92284 21.0467 6.93239 19.6881 6.08477 18.4698C4.39032 15.9839 3.07129 11.4643 4.83989 8.38888C5.69687 6.88054 7.25942 5.90922 8.92967 5.88335C9.66518 5.86824 10.3706 6.15295 10.989 6.40254C11.4619 6.59341 11.8839 6.76373 12.2296 6.76373C12.5332 6.76373 12.9434 6.60022 13.4214 6.40964C14.1748 6.10929 15.0968 5.74173 16.0361 5.84101C16.6784 5.85983 18.5063 6.0958 19.6857 7.82286L19.6832 7.82434Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === DownloadIconVariant.GOOGLE && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4456 7.05231L16.0541 9.13518L13.4694 11.6336L4.53789 3L12.4456 7.05231ZM16.6082 9.45686L19.8872 11.3489V11.3492C20.0805 11.4609 20.1961 11.6614 20.1961 11.8847C20.1961 12.108 20.0805 12.3085 19.8872 12.4198L16.376 14.4463L13.9114 12.0637L16.6082 9.45686ZM4.66973 21L12.4597 16.7087L15.8221 14.7675L13.4699 12.4934L4.66973 21ZM4 20.7859L4.00856 3.34926L13.0232 12.0635L4 20.7859Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === DownloadIconVariant.GOOGLE_COLOR && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 20" fill="none">
          <path
            d="M8.90971 9.5527L0.625 18.3431C0.881709 19.2999 1.75297 20 2.78758 20C3.19987 20 3.58883 19.8911 3.92333 19.6888L3.94666 19.6733L13.266 14.2979L8.90193 9.54492L8.90971 9.5527Z"
            fill="#EA4335"
          />
          <path
            d="M17.2913 8.05927H17.2835L13.2618 5.71777L8.72656 9.75511L13.2773 14.3059L17.2835 11.9955C17.9837 11.6143 18.4582 10.8753 18.4582 10.0274C18.4582 9.17946 17.9914 8.44045 17.2913 8.06705V8.05927Z"
            fill="#FBBC04"
          />
          <path
            d="M0.624666 1.66479C0.577992 1.85149 0.546875 2.03819 0.546875 2.24045V17.7753C0.546875 17.9775 0.570213 18.1642 0.624666 18.3509L9.18943 9.78615L0.624666 1.66479Z"
            fill="#4285F4"
          />
          <path
            d="M8.97195 10.0039L13.2582 5.71762L3.94667 0.318942C3.61216 0.116686 3.21543 0 2.78758 0C1.75297 0 0.881709 0.707897 0.625 1.65694L8.97195 9.99611V10.0039Z"
            fill="#34A853"
          />
        </svg>
      )}
      {variant === DownloadIconVariant.DOWNLOAD && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7599 2C13.2859 2 13.7123 2.40701 13.7123 2.90909V12.5324L16.8482 9.53899C17.2201 9.18397 17.8232 9.18397 18.1951 9.53899C18.567 9.89402 18.567 10.4696 18.1951 10.8246L13.4332 15.3701C13.0612 15.7251 12.4582 15.7251 12.0863 15.3701L7.3244 10.8246C6.95247 10.4696 6.95247 9.89402 7.3244 9.53899C7.69633 9.18397 8.29934 9.18397 8.67127 9.53899L11.8075 12.5327V2.90909C11.8075 2.40701 12.2339 2 12.7599 2ZM4.31818 13.8182C4.31818 13.3161 3.91117 12.9091 3.40909 12.9091C2.90701 12.9091 2.5 13.3161 2.5 13.8182V16.5455C2.5 19.5579 4.94208 22 7.95455 22H17.0455C20.0579 22 22.5 19.5579 22.5 16.5455V13.8182C22.5 13.3161 22.093 12.9091 21.5909 12.9091C21.0888 12.9091 20.6818 13.3161 20.6818 13.8182V16.5455C20.6818 18.5538 19.0538 20.1818 17.0455 20.1818H7.95455C5.94624 20.1818 4.31818 18.5538 4.31818 16.5455V13.8182Z"
            fill={fill}
          />
        </svg>
      )}
    </i>
  );
}

export default DownloadIcon;
